import dotProp from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

export default function event_details(state = states.event_details, action) {
    switch (action.type) {
        case actionTypes.UPDATE_EVENT_STATE: {
            return dotProp.set(state, action.path, action.payload);
        }

        case actionTypes.EVENTS_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    events_loading: true,
                    events_loaded: false
                }
            };
        }

        case actionTypes.EVENTS_LOADED: {
            return {
                ...state,
                events: action.payload,
                loaders: {
                    ...state.loaders,
                    events_loading: false,
                    events_loaded: true,
                }
            };
        }

        case actionTypes.EVENTS_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    events_loading: false,
                    events_loaded: false,
                }
            };
        }

        case actionTypes.UPDATE_EVENT_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    event_updating: true,
                }
            };
        }

        case actionTypes.UPDATE_EVENT_LOADED: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    event_updating: false,
                }
            };
        }

        case actionTypes.EVENT_CREATED: {
            return {
                ...state,
                events: action.payload.data.createdEvent ? [action.payload.data.createdEvent, ...state.events] : [...state.events],
            };
        }


        case actionTypes.EVENT_UPDATED: {
            const index = state.events.findIndex((event) => {
                return (action.payload.data.event && action.payload.data.event.eventId === event.eventId)
            });
            return {
                ...state,
                events: index !== -1 ? [...state.events.slice(0, index), action.payload.data.event, ...state.events.slice(index + 1)] : [...state.events],
            };
        }

        case actionTypes.EVENT_DELETED: {
            const index = state.events.findIndex((event) => {
                return (event.eventId === action.payload.data.eventId)
            });
            return {
                ...state,
                events: index !== -1 ? [...state.events.slice(0, index), ...state.events.slice(index + 1)] : [...state.events],
            };
        }

        case actionTypes.EVENT_HISTOGRAM_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    histogram_loading: true,
                }
            };
        }

        case actionTypes.EVENT_HISTOGRAM_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    histogram_loading: false,
                    histogram_load_error: true,
                }
            };
        }

        case actionTypes.EVENT_HISTOGRAM_RECEIVED: {
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    histogram: action.payload.EventsAnalyticsData
                },
                loaders: {
                    ...state.loaders,
                    histogram_loading: false,
                    histogram_load_error: false,
                }
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/event_details/reducers.js